import DealerUi from '@dealer-group/dealerui';
import {ApiDealerXClient} from '@dealer-group/dealer-api-clients'

import qs from "./core/router-builder/queryString";
import Vue from "vue";

const dealerXClient = {
    baseURL: process.env.VUE_APP_DX_URL || null,
    paramsSerializer: function (params) {
        /**
         * Serializacja zagłębionych parametrów w URL
         */
        return qs.stringify(params, {
            arrayFormat: 'brackets',
            encodeValuesOnly: true
        })
    },
};

Vue.use(DealerUi, {dealerXClient});

ApiDealerXClient.initialize(dealerXClient);
